import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, property } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import config from 'config';
import { routeMap } from '../../../../router';
import { startRequest } from '../../../Authorization/redux/logout/actions';
import { clearErrorsStore } from '../../redux/catchErrorRequest/actions';
import errorMessages from 'constants/errorMessages';
import Modal from 'components/Modal';
import Warning from 'components/Warning';
import { selectRouter } from 'modules/App/utils/selectors';

class ErrorLoadingData extends Component {
  static propTypes = {
    catchErrors: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.shape({
        errorCode: PropTypes.arrayOf(PropTypes.number),
      }),
    ]),
    router: PropTypes.object,
    logout: PropTypes.func.isRequired,
    clearErrorsStore: PropTypes.func.isRequired,
  };

  handleOnClose = () => {
    const { catchErrors, clearErrorsStore } = this.props;
    const isAccessForbiddenError = catchErrors && catchErrors.includes(403);

    clearErrorsStore();
    if (this.props.router.pathname !== routeMap.login && !isAccessForbiddenError) {
      this.props.logout();
    }
  };

  render() {
    const { catchErrors } = this.props;
    const showModal = !isEmpty(catchErrors);

    const isAccessForbiddenError = catchErrors && catchErrors.includes(403);
    const accessForbiddenErrorMessage = config.isInspectorArm
      ? errorMessages.errorForbiddenForARM
      : errorMessages.errorForbidden;

    const errorMessage = isAccessForbiddenError
      ? accessForbiddenErrorMessage
      : errorMessages.errorLoadingData;

    return showModal ? (
      <Modal
        horizontalCentering={true}
        popupWrapperStyle={{ borderRadius: '10px' }}
        onClose={this.handleOnClose}
        zIndex={5001}
        showModal={showModal}
      >
        <Warning style={{ marginLeft: '40px' }} message={errorMessage} />
      </Modal>
    ) : null;
  }
}

const mapStateToProps = createStructuredSelector({
  catchErrors: property('app.catchErrors.errorCodes'),
  router: selectRouter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout: startRequest,
      clearErrorsStore: clearErrorsStore,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ErrorLoadingData);
